import MetaBaseDashBoardSeven from "../../features/MetabaseDashBoard/MetabaseDashBoardSeven"

const MetabaseReport6 = () => {
    return (
    <div><MetaBaseDashBoardSeven/></div>
  )
}

export default MetabaseReport6